import { StrategyBuilderFunction, EMPTY_STRATEGY } from 'utils/shared/optionProfitCalculator/types';
import { addShortCall, addShortPut } from 'utils/shared/optionProfitCalculator/addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  getStrategyLegStrikeDirection,
  getStrikeDistance,
  DEFAULT_STOCK_POSITION,
} from 'utils/shared/optionProfitCalculator/utils';

export const coveredShortStrangle: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strike,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const strikePrice = strike
    ? strike
    : findClosestStrikePrice(strikesAtExpiration, getStrikeDistance({ price: spot, unit: 0 }));

  if (strikePrice === -1) {
    return EMPTY_STRATEGY;
  }

  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  // Selecting strike prices for the call and put
  const putStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: -2 }),
  );
  const callStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: 2 }),
  );

  const stockPosition = {
    price: spot,
    quantity: DEFAULT_STOCK_POSITION * contractMultiplier, // 100 shares per strategy unit
  };

  const cashPosition = {
    amount: strikePrice * DEFAULT_STOCK_POSITION,
  };

  return {
    optionPositions: [
      addShortCall({
        strike: callStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[callStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[callStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      addShortPut({
        strike: putStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[putStrike]?.p?.a || 0,
          bid: strikesAtExpiration?.c?.[putStrike]?.p?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
    ],
    stockPositions: [stockPosition],
    cashPositions: [cashPosition],
  };
};
